import { createApp } from 'vue'
import WaiPanel from './WaiPanel.vue'

export function renderWai() {
  const root = document.querySelector('#wai-platform')

  if (!root) return

  createApp(WaiPanel).mount(root)
}
